// TODO: Fix that this is imported as `apiClient` not `api-client`
import axios, { type AxiosInstance } from 'axios';
import { MissingApiClientError } from 'errors';

let apiClient: AxiosInstance | null = null;

export function setProvidedApiClient({ axiosInstance }: { axiosInstance: AxiosInstance }): void {
  apiClient = axiosInstance;
}

export function getApiClient() {
  if (!apiClient) {
    throw new MissingApiClientError();
  }

  return apiClient;
}

const awsApiClient = axios.create();

export function getAwsApiClient() {
  return awsApiClient;
}

export { type AxiosRequestConfig } from 'axios';
